import { render, staticRenderFns } from "./SaveAdBoardRow.vue?vue&type=template&id=112319a4&scoped=true"
import script from "./SaveAdBoardRow.vue?vue&type=script&lang=js"
export * from "./SaveAdBoardRow.vue?vue&type=script&lang=js"
import style0 from "./SaveAdBoardRow.vue?vue&type=style&index=0&id=112319a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112319a4",
  null
  
)

export default component.exports